
import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
const useStyles = createUseStyles({
  subContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "6px",
    minHeight: "90px",
    minWidth: "202px",
    borderRadius: "15px",
    padding: "18px 20px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    flex: 1,
    overflow: "hidden",
    "& > *": {
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "@media (max-width:479.95px)": {
      minWidth: 0,
      padding: "16px",
    },
  },
});

export default useStyles;
